import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';
import { X } from 'lucide-react';

const TerminacionLaboralModal = ({ open, onClose, onSubmit, trabajadorNombre }) => {
  const [formData, setFormData] = useState({
    tipo_terminacion: '',
    fecha_terminacion: new Date().toISOString().split('T')[0],
    motivo: '',
    observaciones: '',
    monto_liquidacion: ''
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-emerald-900">
            Terminación Laboral
          </DialogTitle>
          <DialogDescription>
            Registrar la terminación laboral de <strong>{trabajadorNombre}</strong>
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          {/* Tipo de Terminación */}
          <div>
            <Label className="text-emerald-900 font-semibold">
              Tipo de Terminación *
            </Label>
            <Select 
              value={formData.tipo_terminacion} 
              onValueChange={(value) => handleChange('tipo_terminacion', value)}
              required
            >
              <SelectTrigger className="mt-1">
                <SelectValue placeholder="Selecciona el tipo" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="despido">Despido</SelectItem>
                <SelectItem value="renuncia">Renuncia</SelectItem>
                <SelectItem value="liquidacion">Liquidación</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Fecha de Terminación */}
          <div>
            <Label className="text-emerald-900 font-semibold">
              Fecha de Terminación *
            </Label>
            <Input
              type="date"
              value={formData.fecha_terminacion}
              onChange={(e) => handleChange('fecha_terminacion', e.target.value)}
              className="mt-1"
              required
            />
          </div>

          {/* Motivo */}
          <div>
            <Label className="text-emerald-900 font-semibold">
              Motivo
            </Label>
            <Input
              type="text"
              value={formData.motivo}
              onChange={(e) => handleChange('motivo', e.target.value)}
              placeholder="Ejemplo: Finalización de contrato, reducción de personal, etc."
              className="mt-1"
            />
          </div>

          {/* Observaciones */}
          <div>
            <Label className="text-emerald-900 font-semibold">
              Observaciones
            </Label>
            <Textarea
              value={formData.observaciones}
              onChange={(e) => handleChange('observaciones', e.target.value)}
              placeholder="Detalles adicionales sobre la terminación..."
              className="mt-1"
              rows={3}
            />
          </div>

          {/* Monto de Liquidación (solo si es liquidación) */}
          {formData.tipo_terminacion === 'liquidacion' && (
            <div>
              <Label className="text-emerald-900 font-semibold">
                Monto de Liquidación (₡)
              </Label>
              <Input
                type="number"
                step="0.01"
                value={formData.monto_liquidacion}
                onChange={(e) => handleChange('monto_liquidacion', e.target.value)}
                placeholder="0.00"
                className="mt-1"
              />
            </div>
          )}

          {/* Advertencia */}
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
            <p className="text-sm text-amber-800">
              <strong>⚠️ Importante:</strong> Esta acción marcará al trabajador como <strong>Inactivo</strong> y 
              cerrará su periodo laboral actual. Esta operación no se puede deshacer.
            </p>
          </div>

          {/* Botones */}
          <div className="flex justify-end gap-2 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="border-gray-300"
            >
              <X className="w-4 h-4 mr-2" />
              Cancelar
            </Button>
            <Button
              type="submit"
              className="bg-red-600 hover:bg-red-700 text-white"
              disabled={!formData.tipo_terminacion}
            >
              Registrar Terminación
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default TerminacionLaboralModal;
